import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import LayerFarmListActions, { LayerFarmListTypes } from '../Stores/LayerFarmList/Actions';

const getAppStore = state => state.app;

export function* layerFarmListFetchList({ procType, currentPage, sorts, filters, pageSize }) {
  try {
    yield put(LayerFarmListActions.layerFarmListFetchListLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `layerFarm/indexProcess/${procType}/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        LayerFarmListActions.layerFarmListFetchListSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(LayerFarmListActions.layerFarmListFetchListLoading(false));
  }
}

export function* layerFarmListGoToResource({ resId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/itemDetail/update/${resId}/GENERAL`));
}

export function* layerFarmListGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/ITEM/${hdrId}/Item`));
}

export function* layerFarmListNewResource() {
  const app = yield select(getAppStore);
  const itemType = 1; // STOCK_ITEM
  yield put(push(`${app.appPath}/itemDetail/create/${itemType}/GENERAL`));
}

export const saga = [
  takeLatest(LayerFarmListTypes.LAYER_FARM_LIST_FETCH_LIST, layerFarmListFetchList),
  takeLatest(LayerFarmListTypes.LAYER_FARM_LIST_GO_TO_AUDIT, layerFarmListGoToAudit),
  takeLatest(LayerFarmListTypes.LAYER_FARM_LIST_GO_TO_RESOURCE, layerFarmListGoToResource),
  takeLatest(LayerFarmListTypes.LAYER_FARM_LIST_NEW_RESOURCE, layerFarmListNewResource)
];
